'use client'

import React, { useState } from 'react'

export function Collapsible({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false)

  return (
    <div>
      {React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          if (child.type === CollapsibleTrigger) {
            return React.cloneElement(child as React.ReactElement<any>, {
              onClick: () => setOpen(!open)
            })
          }
          if (child.type === CollapsibleContent) {
            return open ? child : null
          }
        }
        return child
      })}
    </div>
  )
}

export function CollapsibleTrigger({
  children,
  onClick,
  className = '',
  ...props
}: {
  children: React.ReactNode
  onClick?: () => void
  className?: string
}) {
  return (
    <button onClick={onClick} className={className} {...props}>
      {children}
    </button>
  )
}

export function CollapsibleContent({ children }: { children: React.ReactNode }) {
  return <div>{children}</div>
}
